import React from 'react';

const Visa = () => {
    return (
      <svg
        className="icon--visa-card"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23 8"
      >
        <path
          d="M8.76 0.56L5.89 7.45H4L2.61 2C2.59877 1.87067 2.55416 1.74647 2.48054 1.63954C2.40692 1.53262 2.30681 1.44663 2.19 1.39C1.63566 1.1245 1.05149 0.926424 0.449997 0.8V0.6H3.45C3.64854 0.602338 3.83984 0.674934 3.98995 0.804908C4.14007 0.934882 4.23928 1.11383 4.27 1.31L5.01 5.31L6.85 0.62L8.76 0.56ZM16.09 5.2C16.09 3.39 13.59 3.29 13.61 2.47C13.61 2.23 13.85 1.96 14.36 1.9C14.9597 1.83927 15.5647 1.94298 16.11 2.2L16.42 0.74C15.888 0.545373 15.3265 0.443887 14.76 0.44C13.01 0.44 11.76 1.37 11.76 2.72C11.76 3.72 12.64 4.26 13.31 4.59C13.98 4.92 14.23 5.15 14.23 5.45C14.23 5.91 13.68 6.11 13.17 6.12C12.5363 6.13669 11.9092 5.98852 11.35 5.69L11 7.2C11.6379 7.44526 12.3166 7.56741 13 7.56C14.86 7.56 16.07 6.64 16.08 5.2H16.09ZM20.7 7.45H22.33L20.91 0.56H19.41C19.247 0.55983 19.0876 0.608258 18.9522 0.6991C18.8168 0.789941 18.7116 0.919072 18.65 1.07L16 7.45H17.86L18.22 6.45H20.49L20.7 7.45ZM18.7 5.01L19.64 2.43L20.2 5L18.7 5.01ZM11.26 0.56L9.8 7.45H8.06L9.52 0.56H11.26Z"
          fill="currentColor"
        />
      </svg>
    );
}

export default Visa;
